const Component = ({
    startLabel,
    endLabel
}: {
    startLabel: string;
    endLabel: string;
}) => (
    <>
        <div className="editorTimeline__timeGrid">
            <div className="editorTimeline__timeGridInner js-timegrid-inner"></div>
        </div>
        <div className="editorTimeline__layers js-timeline-wrapper">
            <div
                className="editorTimeline__layersInner timeline-elastic js-timeline-elastic"
                style={{ width: "100%", position: "relative" }}
            >
                <div className="editorTimeline__layersScrollable editorTimeline__layersInner timeline-wrapper js-timeline-container">
                    {/* Add child timeline representation here */}
                </div>
            </div>
        </div>

        <div className="grTimescale">
            <div className="grTimescale__label grTimescale__label--start js-label-start">
                {startLabel}
            </div>
            <div className="grTimescale__container js-timescale-wrapper">
                <div className="grTimescale__clip js-timeline-clip"></div>
                <div className="grTimescale__slider">
                    <div className="js-timescale"></div>
                </div>
                <div
                    className="grTimescale__lollipop js-timeline-lollipop"
                    data-type="timescale"
                ></div>
            </div>
            <div className="grTimescale__label grTimescale__label--end js-label-end">
                {endLabel}
            </div>
            <i className="js-zoom-out gb-icon-minus grTimescale__zoom-out grTimescale__icon"></i>
            <i className="js-zoom-in gb-icon-plus grTimescale__zoom-in grTimescale__icon"></i>
            <i className="js-zoom-to-selection gb-icon-zoomtoselection grTimescale__icon"></i>
        </div>
    </>
);
export default Component;
